import { PersonTasksSummary, ContactInfo, AddressInfo } from '@/types/portal/Person';

import { api } from "../api";
import { getErrorResponse } from "../errorHandler";

export const getContactInformation = async (): Promise<any> => {
  const { data } = await api.get<ContactInfo>(`/Person/contact`);

  return data;
};

export const changeAddressInformation = async (addressInfo: AddressInfo): Promise<any> => {
  const { data } = await api.post<any>(`/Person/address`, addressInfo);

  return data;
};

export const changeContactInformation = async (contactInfo: ContactInfo): Promise<any> => {
  const { data } = await api.post<any>(`/Person/contact`, contactInfo);

  return data;
};

export const changePassword = async (currentPassword: string, newPassword: string): Promise<any> => {
  const request = {currentPassword, newPassword}

  const { data } = await api.post<any>(`/Person/changePassword`, request);

  return data;
};

export const getTasksSummary = async (): Promise<PersonTasksSummary> => {
  const { data } = await api.get<PersonTasksSummary>(`/Person/tasks`);

  return data;
};

export const getCommunicationPreferences = async (): Promise<any> => {
    const { data } = await api.get<any>(`/Person/communication`);

    return data;
};

export const changeCommunicationPreferences = async (email: boolean, sms: boolean, digitalOnlyTitleCert: boolean): Promise<any> => {
    const { data } = await api.post<any>(`/Person/communication`, {email, sms, digitalOnlyTitleCert});

    return data;
};

export const getDogsByOwner = async (params: any): Promise<any> => {
  const { data } = await api.get<object>(`/Person/dogs`, {params: params});

  return data;
};

export const getKennelsByOwner = async (): Promise<any> => {
  const { data } = await api.get<object>(`/Person/kennels`);

  return data;
};

export const getMyPayments = async (): Promise<any> => {
  const { data } = await api.get<object>(`/Person/payments`);

  return data;
};

export const getUserConfirmation = async (value: string, isEmail: boolean): Promise<any> => {
  try {
    const { data } = await api.post<any>(`/Person/confirmation`, { value, isEmail })
    return {...data, success: true}
  } catch (err) {

    const response = getErrorResponse(err);
    if (response?.status === 500) {
      return {error: response.data?.error, success: false};
    }

    return {error: err, success: false};
  };
}

export const verifyAccountRecovery = async (challengeId: string, code: string): Promise<any> => {
  const { data } = await api.post<any>(`/Person/recovery/verify`, { challengeId, code });
  return data;
};

export const forgotPassword = async (recoveryToken: string, newPassword: string): Promise<any> => {
  const request = {recoveryToken, newPassword}

  const { data } = await api.post<any>(`/Person/forgotPassword`, request);

  return data;
};
  
export default {
  getTasksSummary,
  getCommunicationPreferences,
  changeCommunicationPreferences,
  getDogsByOwner,
  getKennelsByOwner,
  getContactInformation,
  changeAddressInformation,
  changeContactInformation,
  changePassword,
  getMyPayments,
  getUserConfirmation,
  verifyAccountRecovery,
  forgotPassword,
};
